const getLanguagesLiviu = () => {
  return [{ value: 'cos', code: 'cos', label: 'Corse', isLanguage: true, assistant: 1 }];
};

export const getLanguages = () => {
  if (process.env.GATSBY_LIV === 'liviu') return getLanguagesLiviu();
  return [
    { value: 'cos', code: 'cos', label: 'Corse', isLanguage: true, assistant: 1 },
    { value: 'en', code: 'en', label: 'Anglais', isLanguage: true, assistant: 2 },
    { value: 'fr', code: 'fr', label: 'Français', isLanguage: true, assistant: 2 },
    { value: 'it', code: 'it', label: 'Italien', isLanguage: true, assistant: 2 },
    { value: 'pt', code: 'pt', label: 'Portugais', isLanguage: true, assistant: 2 },
    { value: 'ar', code: 'ar', label: 'Arabe', isLanguage: true, assistant: 2 },
    { value: 'pl', code: 'pl', label: 'Polonais', isLanguage: true, assistant: 2 },
  ];
};

export const getFirstMessages = () => {
  return {
    cos: 'Salute, sò LIVIA, di chè vulerebbe parlà oghje?',
    en: "Hello, I'm LIVIA, what would you like to talk about today?",
    fr: "Bonjour, je suis LIVIA, de quoi aimeriez-vous parler aujourd'hui?",
    it: 'Ciao, sono LIVIA, di cosa vorresti parlare oggi?',
    pt: 'Olá, sou LIVIA, sobre o que gostaria de falar hoje?',
    ar: 'مرحبًا، أنا LIVIA، ما الذي ترغب في التحدث عنه اليوم؟',
    pl: 'Cześć, jestem LIVIA, o czym chciałbyś dzisiaj porozmawiać?',
  };
};

export const getFirstMessagesLiviu = () => {
  return {
    cos: 'Salute, sò LIVIU, di chè vulerebbe parlà oghje?',
    en: "Hello, I'm LIVIU, what would you like to talk about today?",
    fr: "Bonjour, je suis LIVIU, de quoi aimeriez-vous parler aujourd'hui?",
    it: 'Ciao, sono LIVIU, di cosa vorresti parlare oggi?',
    pt: 'Olá, sou LIVIU, sobre o que gostaria de falar hoje?',
    ar: 'مرحبًا، أنا LIVIU، ما الذي ترغب في التحدث عنه اليوم؟',
    pl: 'Cześć, jestem LIVIU, o czym chciałbyś dzisiaj porozmawiać?',
  };
};

export const getFirstMessagesLivquestCalvi = () => {
  return {
    en: `Hello, fellow adventurer.

If my words feel too old-fashioned or too serious, just let me know. I can speak more simply if children are joining you.

You can answer me by writing, or by speaking for a deeper immersion (🎙️ icon).

If you wish to hear my voice, activate the small speaker (AUTO 🔊) at the top right of your screen.

And if your heart longs to drift into the adventure and take your time, you can press the 🎵 button to listen to the album composed especially for this quest.

Finally, to explore your logbook, look at the Menu icon in the top left.

Now that everything is within your reach… are you ready to dive into the story of my life?`,
    fr: `Bonjour, ami de l’aventure.

Si mes mots te paraissent trop anciens ou trop sérieux, fais-le-moi savoir. Je peux parler plus simplement si des enfants t’accompagnent.

Tu peux me répondre en écrivant, ou bien en parlant pour plus d’immersion (icône 🎙️).

Si tu souhaites entendre mes paroles, active le petit haut-parleur (AUTO 🔊) en haut à droite de ton écran.

Et si ton cœur désire se laisser porter par l’aventure et prendre ton temps, tu peux activer le bouton 🎵 afin d’écouter l’album composé spécialement pour cette quête.

Enfin, pour explorer ton journal de bord, regarde en haut à gauche l’icône Menu.
Maintenant que tout t’est accessible… es-tu prêt à plonger dans le récit de ma vie ?`,
    it: `Ciao, amico dell’avventura.

Se le mie parole ti sembrano troppo antiche o troppo serie, fammelo sapere. Posso parlare in modo più semplice se ci sono dei bambini con te.

Puoi rispondermi scrivendo, oppure parlando per un’immersione più profonda (icona 🎙️).

Se desideri ascoltare la mia voce, attiva il piccolo altoparlante (AUTO 🔊) in alto a destra dello schermo.

E se il tuo cuore vuole lasciarsi trasportare dall’avventura e prendersi il suo tempo, puoi premere il pulsante 🎵 per ascoltare l’album composto apposta per questa missione.

Infine, per esplorare il tuo diario di bordo, guarda l’icona Menu in alto a sinistra.

Ora che tutto ti è accessibile… sei pronto a tuffarti nel racconto della mia vita?`,
  };
};

export const getSelectScenarioMessage = () => {
  return {
    cos: 'Vulete sceglie un scenariu?',
    en: 'Do you want to choose a scenario?',
    fr: 'Voulez-vous choisir un scénario ?',
    it: 'Vuoi scegliere uno scenario?',
    pt: 'Você quer escolher um cenário?',
    ar: 'هل تريد اختيار سيناريو؟',
    pl: 'Czy chcesz wybrać scenariusz?',
  };
};
